import styled, { keyframes } from 'styled-components';
import Perfil from './Foto.jpg';
import {Link} from "react-router-dom"
const Header = styled.div`
    display: ${(props) => props.display};
    justify-content: center;
    margin-top: 25px;
`;

const HeaderContainer = styled.div`
    width: 1000px;
    height: 500px;
    background-color: #000000;
    border: 1px solid #1b1b1b;
    box-shadow: 0px 8px 30px #000000;
    border-radius: 15px;
`;

const HeaderDivImg = styled.div`
    display: grid;
    justify-content: start;
    margin-top: 100px;
    margin-left: 60px;
    img {
        width: 273px;
        height: 274px;
        border-radius: 100%;
        border: 1px solid #000000;
        box-shadow: 0px 8px 30px #1b1b1b;
    }
`;

const HeaderDivspan = styled.div`
    display: flex;
    width: 400px;
    height: 181px;
    margin-left: 450px;
    margin-top: -220px;
`;

const HeaderSpan = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    color: white;
`;

const HeaderButton = styled.div`
    display: flex;
    width: 100%;
    height: 63px;
    background: #3f8e00;
    border: 1px solid #62ba1b;
    box-shadow: 0px 8px 30px rgba(63, 142, 0, 0.5);
`;

const HeaderH1 = styled.h1`
    
    margin-left:700px;
    margin-top: 20px;
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: white;
`;

const Apresentation = ({ displayS }) => {
    return (
        <Header display={displayS}>
            <HeaderContainer>
                <HeaderDivImg>
                    <img src={Perfil} />
                </HeaderDivImg>
                <HeaderDivspan>
                    <HeaderSpan>
                        Ola seja bem vindo ao meu portifolio , sou Programador
                        Junior,clique no botão abaixo para me conhecer e conhe
                        cer meus projetos que estão prestes a serem
                        desenvolvidos...
                    </HeaderSpan>
                </HeaderDivspan>
                <HeaderButton>
                    <HeaderH1><Link to="/resumo" style={{textDecoration:"none", color:"white"}}>Clique aqui para continuar</Link></HeaderH1>
                </HeaderButton>
            </HeaderContainer>
        </Header>
    );
};

export default Apresentation;
